import { msalInstance, apiScopes } from '../msalConfig';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { getToken as getLegacyToken } from '../utilities/auth';

async function getEntraToken() {
    const account = msalInstance.getAllAccounts()[0];
    if (!account) return null;
    try {
        const result = await msalInstance.acquireTokenSilent({ scopes: apiScopes, account });
        return result.accessToken;
    } catch (e) {
        if (e instanceof InteractionRequiredAuthError) {
            await msalInstance.acquireTokenRedirect({ scopes: apiScopes, account });
            return null;
        }
        throw e;
    }
}

export async function getActiveToken() {
    const entra = await getEntraToken();
    if (entra) return entra;
    return getLegacyToken() || null;
}

export async function authFetch(url, options = {}) {
    const token = await getActiveToken();
    const headers = {
        ...(options.headers || {}),
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    };
    return fetch(url, { ...options, headers });
}

export async function authFetchBlobUrl(url, options = {}) {
    const res = await authFetch(url, options);
    if (!res.ok) throw new Error(`Failed to fetch ${url}: ${res.status}`);
    const blob = await res.blob();
    return URL.createObjectURL(blob);
}
